// extracted by css-extract-rspack-plugin
export default {"target-list":"UvJZqrF___target-list","targetList":"UvJZqrF___target-list","source":"dUaQv2A___source"};